import { gateway } from "../../../gateway";

interface CreateTimeSheetParams {
    jobEventUid: string;
    workforceUid: string;
    startAt: string;
    endAt: string;
}

export const createTimeSheet = async ({ jobEventUid, workforceUid, startAt, endAt }: CreateTimeSheetParams) => {
    const { data } = await gateway.post("/timesheets", {
        jobEventUid,
        workforceUid,
        startAt,
        endAt,
    });

    return data;
};